module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Da-Fb-Ge-Hc-Ia.8c3e6198.png";